export default "__VITE_ASSET__fXJxQFyA__"